import React, { useEffect, useState } from 'react';
import { marked } from 'marked';
import Seo from '../components/Seo';
import { Shell, articleClass } from '../components/Article';

// One entry per markdown page. The .md lives in public/ at `${path}.md`,
// so prerender + sitemap discover pages from the files themselves.
export const PAGES = [
  {
    path: '/compare/emboscale-vs-traditional-olp',
    label: 'Emboscale vs traditional OLP',
    title: 'Emboscale vs traditional offline programming (OLP) — Emboscale',
    description:
      'An honest comparison of the Factory Agent with traditional robot offline programming tools like RoboDK, Octopuz, and Robotmaster — and when each is the better choice.',
  },
  {
    path: '/compare/emboscale-vs-enterprise-suites',
    label: 'Emboscale vs enterprise suites',
    title: 'Emboscale vs enterprise simulation suites — Emboscale',
    description:
      'How the Factory Agent compares to enterprise factory-simulation suites like Siemens Tecnomatix and Dassault Delmia — and when each is the better choice.',
  },
  {
    path: '/capabilities/factory-layout-planning',
    label: 'Factory layout planning',
    title: 'AI factory layout planning software — Emboscale',
    description:
      'What factory layout planning is, why it usually takes weeks, and how the Factory Agent turns a plain-language prompt into a dimensioned 3D layout in minutes.',
  },
  {
    path: '/capabilities/line-balancing',
    label: 'Line balancing',
    title: 'Line balancing software — takt time, cycle time, bottlenecks — Emboscale',
    description:
      'What line balancing means in manufacturing, how takt time and cycle time relate, and how the Factory Agent balances a line and re-balances it from a prompt.',
  },
  {
    path: '/capabilities/shift-scheduling',
    label: 'Shift scheduling',
    title: 'Production shift scheduling with CP-SAT — Emboscale',
    description:
      'Why plant schedules built in spreadsheets break, what constraint solving changes, and how the Factory Agent produces auditable shift schedules with due-date risk flagging.',
  },
  {
    path: '/capabilities/robot-program-verification',
    label: 'Robot program verification',
    title: 'Robot program verification — the 8-check kinematic oracle — Emboscale',
    description:
      'Why AI-written robot programs must be machine-verified, and what the 8-check kinematic verification suite proves before any program ships in a deploy pack.',
  },
];

const ContentPage = ({ page }) => {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${page.path}.md`)
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((md) => setHtml(marked.parse(md.replace(/^---[\s\S]*?---\s*/, ''))))
      .catch(() => setHtml('<p>Page not found.</p>'));
  }, [page.path]);

  return (
    <Shell>
      <Seo title={page.title} description={page.description} path={page.path} />
      <article className={articleClass} dangerouslySetInnerHTML={html ? { __html: html } : undefined}>
        {html ? undefined : <p className="text-gray-500 mt-8">Loading…</p>}
      </article>
    </Shell>
  );
};

export default ContentPage;
